<template>
    <transition name="slide-fade">
        <router-view :key="$route.fullPath"/>
    </transition>
</template>
<script>
export default {
    name:'finance-layout'
}
</script>
<style scoped>
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
  transform: translateX(40px);
}
.slide-fade-enter-to, .slide-fade-leave {
  opacity: 1;
  transform: translateX(0);
}
</style>